<template>
  <div>
    <div
      style="
        position: fixed;
        top: 20px;
        left: 0px;
        z-index: 4;
        backdrop-filter: blur(2px);
      "
      v-if="loaderStatus"
    >
      <Spinner />
    </div>
    <template
      v-if="
        recruiterData.length === 0 &&
        searchQuery !== '' &&
        searchQuery !== 'Loader'
      "
    >
      <div
        class="
          common-innerbody-container
          d-flex
          justify-content-center
          align-items-center
          mt-1
          flex-column
        "
      >
        <div>
          <img src="../../assets/ReportsNew/panel-wrong-search.svg" alt="" />
        </div>
        <div class="no-matching-results-font mt-1 wordbreak text-center">
          No matching results found for <strong>"{{ searchQuery }}"</strong>
        </div>
      </div>
    </template>
    <template
      v-else-if="
        !loaderStatus && 
        recruiterData.length === 0 &&
        searchQuery === '' &&
        searchQuery !== 'Loader'
      "
    >
      <div
        class="
          common-innerbody-container
          d-flex
          justify-content-center
          align-items-center
          mt-1
          flex-column
        "
      >
        <div>
          <img
            src="../../assets/New-job-dashboard/no-data-recruiters.svg"
            alt=""
          />
        </div>
        <div class="no-matching-results-font mt-1 wordbreak text-center">
          There are no allocated recruiters.
        </div>
      </div>
    </template>
    <template v-else-if="!loaderStatus">
      <div class="mt-4 common-innerbody-container">
        <b-row class="flex-nowrap add-gap">
          <b-col cols="6">
            <b-row class="head">
              <b-col cols="4"> Recruiter Name </b-col>

              <b-col cols="8"> Jobs </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="head">
              <b-col>Position ID</b-col>
            </b-row>
          </b-col>
        </b-row>
        <section class="common-inner-container-overflow">
          <b-row
            class="flex-nowrap add-gap recruiter-item"
            v-for="(recruiter, ind) in recruiterData"
            :key="ind"
          >
            <b-col>
              <b-row class="flex-nowrap add-gap">
                <b-col cols="6" class="set-rec-col-padding">
                  <b-row class="body">
                    <b-col cols="4" class="p-0">
                      <div class="mt-1 text-truncate">
                        {{ recruiter.recruiter.username }}
                      </div>
                    </b-col>

                    <b-col cols="8" class="p-0">
                      <div class="d-flex flex-wrap">
                        <b-avatar-group
                          class="common-blueAvatar-main-container"
                        >
                          <b-avatar
                            class="common-blueAvatar"
                            v-for="(job, index) in recruiter.jobs.slice(0, 10)"
                            :key="index"
                            :style="getAvatarStyle(ind, index)"
                            @click="selectAvatar(ind, index)"
                            :text="job.jobName"
                            :icon="getUserIcon(job.jobName)"
                            button
                            v-b-tooltip.hover.bottom="job.jobName"
                          >
                            {{
                              job.isExpanded
                                ? job.jobName.length > 10
                                  ? job.jobName.slice(0, 10) + "..."
                                  : job.jobName
                                : getUserIcon(job.jobName)
                            }}
                          </b-avatar>
                          <div class="relativeclass">
                            <b-avatar
                              v-closeArray="{
                                ind,
                                property: 'openJobDropdown',
                                array: recruiterData,
                                handler: closeRecDropdown(ind),
                                exclude: ['recDropDown'],
                              }"
                              v-if="recruiter.jobs.length > 10"
                              class="extra-lightblue-div pointer"
                              @click="showMoreJobs(ind)"
                              button
                            >
                              +{{ recruiter.jobs.length - 10 }}
                            </b-avatar>
                            <template
                              v-if="
                                recruiter.jobs.length > 10 &&
                                recruiter.openJobDropdown
                              "
                            >
                              <div
                                class="
                                  recDropDown
                                  rec-view-dropdown
                                  newInt-radio-dropdown
                                  p-0
                                "
                              >
                                <b-form-group
                                  class="
                                    sec-mcq-datacard sec-mcq-datacard-height
                                  "
                                >
                                  <b-form-radio-group
                                    v-model="selectedJob"
                                    class="
                                      newInt-radio-dropdown-inner-content
                                      rec-view-dropdown-inner-content
                                      w-100
                                    "
                                    size="sm"
                                    :options="jobsData"
                                    @change="selectJob(ind)"
                                    buttons
                                    stacked
                                  ></b-form-radio-group>
                                </b-form-group>
                              </div>
                            </template>
                          </div>
                        </b-avatar-group>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="6">
                  <b-row>
                    <b-col class="p-0">
                      <div
                        class="
                          w-100
                          d-flex
                          align-items-center
                          flex-wrap
                          position
                          px-1
                        "
                      >
                        <draggable
                          v-model="recruiter.positions"
                          class="
                            w-100
                            d-flex
                            align-items-center
                            flex-wrap
                            position
                          "
                          group="recruiters"
                          filter=".no-drag"
                          @add="(event) => addPositionID(event, ind)"
                          @start="dragPositionID(ind)"
                        >
                          <template v-if="recruiter.positions.length">
                            <div
                              class="drag-container d-flex align-items-center"
                              v-for="(position, idx) in getPositionIDs(
                                recruiter
                              )"
                              :key="idx"
                              :class="
                                position.highlight
                                  ? 'drag-selected-container'
                                  : ''
                              "
                            >
                              <div class="mr-2 mb-1">
                                <img
                                  v-if="position.highlight"
                                  src="../../assets/New-job-dashboard/white-draganddrop.svg"
                                  alt=""
                                />

                                <img
                                  v-else
                                  src="../../assets/New-job-dashboard/black-draganddrop.svg"
                                  alt=""
                                />
                              </div>

                              <div>{{ position.positionID }}</div>
                            </div>
                          </template>
                          <template v-else>
                            <div class="not-selected-font mt-1">
                              No Position ID is assigned
                            </div>
                          </template>
                          <template v-if="recruiter.positions.length > 10">
                            <button
                              @click="
                                (recruiter.showMore = !recruiter.showMore),
                                  $forceUpdate()
                              "
                              class="show-more-button pointer no-drag"
                            >
                              <span>
                                {{
                                  recruiter.showMore ? "Show Less" : "Show More"
                                }}
                              </span>
                              <img
                                v-if="!recruiter.showMore"
                                src="../../assets/New-job-dashboard/show-more.svg"
                                alt=""
                              />
                              <img
                                v-else
                                src="../../assets/New-job-dashboard/show-less.svg"
                                alt=""
                              />
                            </button>
                          </template>
                        </draggable>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <hr />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </section>
        <div
          class="
            acs-paginaTion-new
            d-flex
            justify-content-between
            align-items-center
            mx-1
          "
        >
          <div class="d-flex">
            <span class="acs-gotopage-text p-1">Go to page</span>
            <b-form-input
              type="text"
              class="acs-pagination-num mr-1"
              v-model="goToPage"
              @keyup.enter="
                goToPage === null || goToPage == '' || !iscontainsNumber
                  ? ''
                  : goToPages(goToPage)
              "
              @keypress="NumbersOnly"
            ></b-form-input>
            <b-button
              class="acs-pagination-addbtn"
              @click="goToPages(goToPage)"
              :disabled="
                goToPage === null || goToPage == '' || !iscontainsNumber
              "
            >
              <span
                ><img src="../../assets/img/accessconnew/blueRight.svg" alt=""
              /></span>
            </b-button>
          </div>
          <div class="pagination">
            <b-pagination
              v-model.number="currentPage"
              @input="getRecruiterData(), (goToPage = null)"
              :total-rows="total"
              :per-page="pageCount"
              align="center"
              first-number
              last-number
            >
              <template #prev-text
                ><span
                  ><img
                    src="../../assets/img/accessconnew/pageleft.svg"
                    alt=""
                  /> </span
              ></template>
              <template #next-text
                ><span
                  ><img
                    src="../../assets/img/accessconnew/pageright.svg"
                    alt="" /></span
              ></template>
            </b-pagination>
          </div>
          <div class="d-flex align-items-center">
            <div class="acs-gotopage-text d-flex justify-content-end">
              Items per page: 10
            </div>
            <div class="acs-gotopage-text mr-2 ml-4 d-flex justify-content-end">
              Showing : <span v-if="pageStart > total">0</span
              ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
              <span class="pl-1"></span> of <span class="pr-1"></span
              >{{ total }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <TransferPositionID
      v-if="showTransferModal"
      :showTransferModal="showTransferModal"
      :positionID="positionID"
      :buttonLoader="buttonLoader"
      @close-transfer-modal="onCloseTransferModal"
      @reassign-possition-id="reassignPossitionId"
    />
  </div>
</template>

<script>
import {
  getRecruiterData,
  changePositionIds,
  getCandidateCount,
} from "../../utils/apiFunctions";
import { NumbersOnly } from "../../controllers/Candidate/helpers";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import TransferPositionID from "../jobs/modals/TransferPositionID.vue";
import Spinner from "@/components/fixedcomponents/Spinner.vue";

export default {
  name: "RecruiterView",
  components: {
    draggable,
    TransferPositionID,
    Spinner,
  },
  data() {
    return {
      recruiterData: [],
      jobsData: [],
      selectPosition: false,
      showTransferModal: false,
      loaderStatus: false,
      buttonLoader: false,
      startIndex: null,
      endIndex: null,
      goToPage: null,
      total: 0,
      currentPage: 1,
      pageCount: 10,
      pageStart: "",
      pageEnd: "",
      positionID: "",
      selectedJob: "",
      jobID: "",
    };
  },
  created() {
    this.$store.commit("searchVUEX/saveSearchQuery", "");
    this.getRecruiterData();
  },
  computed: {
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    iscontainsNumber() {
      return /^[1-9]\d*$/.test(this.goToPage);
    },
    totalPages() {
      return Math.ceil(this.total / this.pageCount);
    },
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.currentPage = 1;
          this.jobID = "";
          this.getRecruiterData();
        }
      }
    },
  },
  methods: {
    updatePage(value) {
      this.pageCount = value;
      this.currentPage = 1;
      this.getRecruiterData();
    },
    goToPages(index) {
      this.currentPage = Math.min(Math.max(1, index), this.totalPages);
      this.goToPage = null;
      this.getRecruiterData();
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    closeRecDropdown(index) {
      return () => {
        this.recruiterData[index].openJobDropdown = false;
        this.$forceUpdate();
      };
    },
    async getRecruiterData() {
      this.loaderStatus = true;
      try {
        let payload = {
          count: this.pageCount,
          page: this.currentPage - 1,
          searchQuery: this.searchQuery,
          jobID: this.jobID,
        };
        let res = await getRecruiterData(payload);
        if (res.status === 200) {
          this.recruiterData = res.data.data.data;
          this.pageStart = res.data.data.pageStart;
          this.pageEnd = res.data.data.pageEnd;
          this.total = res.data.data.total;
          this.recruiterData.map((recruiter) => {
            recruiter.openJobDropdown = false;
            recruiter.showMore = false;
          });
          this.loaderStatus = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    getUserIcon(jobName) {
      if (!jobName || jobName.trim() === "") {
        return "-";
      }
      let parts = jobName
        .trim()
        .split(" ")
        .filter((part) => part !== "");
      if (parts.length > 0 && parts[0]) {
        if (parts.length > 1) {
          if (/[^a-zA-Z]/.test(parts[1])) {
            return parts[0][0].toUpperCase();
          } else {
            return parts[0][0].toUpperCase() + parts[1][0].toUpperCase();
          }
        } else {
          return parts[0][0].toUpperCase();
        }
      }
      return "-";
    },
    async getPositionIDsData(jobID) {
      try {
        this.loaderStatus = true;
        this.jobID = jobID;
        let payload = {
          count: this.pageCount,
          page: this.currentPage - 1,
          searchQuery: this.searchQuery,
          jobID: this.jobID,
        };
        let res = await getRecruiterData(payload);
        if (res.status === 200) {
          const response = res.data.data.data;
          this.recruiterData = this.recruiterData.map((recruiter, index) => {
            const newPositions = response[index]
              ? response[index].positions
              : [];
            return {
              ...recruiter,
              positions: newPositions,
            };
          });
          this.loaderStatus = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    selectAvatar(ind, index) {
      this.selectedJob = "";

      this.recruiterData.forEach((recruiter, recruiterIndex) => {
        if (recruiterIndex === ind) {
          recruiter.jobs.forEach((job, jobIndex) => {
            if (jobIndex !== index) {
              job.isExpanded = false;
            }
          });
        } else {
          recruiter.jobs.forEach((job) => {
            job.isExpanded = false;
          });
        }
        recruiter.openJobDropdown = false;
      });

      const selectedJob = this.recruiterData[ind].jobs[index];
      selectedJob.isExpanded = !selectedJob.isExpanded;

      if (selectedJob.isExpanded) {
        this.getPositionIDsData(selectedJob.jobID);
      } else {
        this.getPositionIDsData();
      }

      this.$forceUpdate();
    },
    getAvatarStyle(ind, index) {
      const jobName = this.recruiterData[ind].jobs[index].jobName;
      const displayName =
        jobName.length > 10 ? jobName.slice(0, 10) + "..." : jobName;
      const context = document.createElement("canvas").getContext("2d");
      context.font = "10px Lato";
      const textWidth = context.measureText(displayName).width;

      const size = this.recruiterData[ind].jobs[index].isExpanded
        ? `${textWidth + 20}px`
        : this.recruiterData[ind].jobs.length === 1
        ? "42px"
        : "33px";
      return {
        width: size,
        height: "33px",
        transition: "width 0.3s, height 0.3s", // Smooth transition for size change
        marginRight: "-10px", // Space between avatars
        background: "unset",
        border: "unset",
        boxShadow: this.recruiterData[ind].jobs[index].isExpanded
          ? "0px 4px 4px 0px #00000080"
          : "unset",
      };
    },
    getPositionIDs(recruiter) {
      if (recruiter.positions.length > 10) {
        if (recruiter.showMore) {
          return recruiter.positions;
        } else {
          return recruiter.positions.slice(0, 10);
        }
      } else {
        return recruiter.positions;
      }
    },
    showMoreJobs(ind) {
      this.recruiterData.map((recruiter, index) => {
        if (ind !== index) {
          recruiter.openJobDropdown = false;
        } else {
          recruiter.openJobDropdown = !recruiter.openJobDropdown;
        }
      });
      this.$forceUpdate();
      this.jobsData = [];
      this.recruiterData[ind].jobs.slice(10).map((job) => {
        this.jobsData.push({ text: job.jobName, value: job.jobID });
      });
    },
    selectJob(ind) {
      this.recruiterData.forEach((recruiter) => {
        recruiter.jobs.forEach((job) => {
          job.isExpanded = false;
        });
      });
      this.getPositionIDsData(this.selectedJob);
      this.recruiterData[ind].openJobDropdown = false;
    },
    addPositionID(event, index) {
      this.endIndex = index;
      if (this.startIndex !== this.endIndex) {
        this.positionID = event.item._underlying_vm_.positionID;
        this.checkForCandidates();
      }
    },
    async checkForCandidates() {
      try {
        let positionIDData = this.recruiterData[this.endIndex].positions.find(
          (pos) => pos.positionID === this.positionID
        );

        let payload = {
          jobID: positionIDData.jobID,
          type: 2,
          recUserID: this.recruiterData[this.startIndex].recruiter.userID,
          positionID: this.positionID,
        };
        let res = await getCandidateCount(payload);
        if (res.status === 200) {
          let movementType = res.data.data.movementType;
          this.reassignPossitionId(movementType);
        } else if (res.status === 409) {
          this.showTransferModal = true;
        }
      } catch (error) {
        console.error(error);
      }
    },
    dragPositionID(index) {
      this.startIndex = index;
    },
    async onCloseTransferModal() {
      this.showTransferModal = false;
      await this.getRecruiterData();
      this.$nextTick(() => {
        const recruiterElement =
          this.$el.querySelectorAll(".recruiter-item")[this.startIndex];
        if (recruiterElement) {
          recruiterElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      });
    },
    async reassignPossitionId(movementType, minutes) {
      try {
        this.buttonLoader = true;
        const index = this.recruiterData[this.endIndex].positions.findIndex(
          (position) => {
            return position.positionID === this.positionID;
          }
        );
        const jobID = this.recruiterData[this.endIndex].positions[index].jobID;
        let payload = {
          jobID: jobID,
          positionID: this.positionID,
          movementType: parseInt(movementType),
          to: this.recruiterData[this.endIndex].recruiter,
          from: this.recruiterData[this.startIndex].recruiter.userID,
          suppressModalFor5Min: minutes,
        };
        let res = await changePositionIds(payload);

        if (res.status === 200) {
          await this.getRecruiterData();
          this.$nextTick(() => {
            const recruiterElement =
              this.$el.querySelectorAll(".recruiter-item")[this.endIndex];
            if (recruiterElement) {
              recruiterElement.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.showTransferModal = false;
        this.buttonLoader = false;
      }
    },
  },
};
</script>

<style scoped>
.acs-paginaTion-new {
  min-width: 1002px;
  max-width: 100%;
}
.show-more-button {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  gap: 10px;
  background: #e1eef7;
  border-radius: 8px;
  border: 1px solid #e1eef7;
  font-family: "Lato";
  font-size: 15px;
  line-height: 18px;
  color: #20639b;
}
</style>
